import { Link } from "react-router-dom";
import UinityBanner from "../assets/images/banner_unity.png";

const EventGetStarted = () => {
  return (
    <Link to="/bmi-photo-capture">
      <img src={UinityBanner} className="w-full mt-10" alt="" />
    </Link>
  );
};

export default EventGetStarted;
